import { apiRequest, api } from "@/lib/api";
import type {
  ConditionInput,
  DiseaseSearchResult,
  PatientAdminHealthUpdate,
  PatientAdminOverview,
  PatientAdminProfileIntake,
} from "@/types";

export const patientAdminApi = {
  getOverview: (patientId: string) =>
    apiRequest<PatientAdminOverview>(() =>
      api.get(`/users/patients/${patientId}/overview/`)
    ),

  getProfileIntake: (patientId: string) =>
    apiRequest<PatientAdminProfileIntake>(() =>
      api.get(`/users/patients/${patientId}/profile-intake/`)
    ),

  updateHealth: (patientId: string, payload: PatientAdminHealthUpdate) =>
    apiRequest<PatientAdminProfileIntake["health"]>(() =>
      api.patch(`/users/patients/${patientId}/profile-intake/health/`, payload)
    ),

  replaceDiseases: (patientId: string, items: ConditionInput[]) =>
    apiRequest<PatientAdminProfileIntake["diseases"]>(() =>
      api.put(`/users/patients/${patientId}/profile-intake/diseases/`, {
        items,
      })
    ),

  replaceFamilyHistory: (
    patientId: string,
    payload: {
      father: ConditionInput[];
      mother: ConditionInput[];
      sibling: ConditionInput[];
    }
  ) =>
    apiRequest<PatientAdminProfileIntake["family_history"]>(() =>
      api.put(
        `/users/patients/${patientId}/profile-intake/family-history/`,
        payload
      )
    ),

  replaceLifestyle: (
    patientId: string,
    payload: PatientAdminProfileIntake["lifestyle"]
  ) =>
    apiRequest<PatientAdminProfileIntake["lifestyle"]>(() =>
      api.put(`/users/patients/${patientId}/profile-intake/lifestyle/`, {
        alcohol: payload.alcohol,
        tobacco: payload.tobacco,
      })
    ),

  markComplete: (patientId: string) =>
    apiRequest<PatientAdminProfileIntake["status"]>(() =>
      api.post(`/users/patients/${patientId}/profile-intake/complete/`)
    ),

  searchDiseases: async (query: string): Promise<DiseaseSearchResult[]> => {
    if (query.trim().length < 2) {
      return [];
    }

    return apiRequest<DiseaseSearchResult[]>(() =>
      api.get("/diseases/", {
        params: {
          search: query,
        },
      })
    );
  },
};
